(function(){
  const KEY = 'pv_qc_deadline';
  const DURATION_MIN = 60;

  function ensureEnd(){
    let end = localStorage.getItem(KEY);
    if (end) end = new Date(end);
    const now = new Date();
    if (!end || (end - now) <= 0) {
      end = new Date(now.getTime() + DURATION_MIN*60*1000);
      localStorage.setItem(KEY, end.toISOString());
    }
    return end;
  }

  function bind(el){
    if (!el || el.dataset.bound) return;
    el.dataset.bound = '1';
    const timerEl = el.querySelector('.qc-timer');
    if (!timerEl) return;

    function tick(){
      const end = ensureEnd();
      const diff = Math.max(0, Math.floor((end - new Date())/1000));
      const m = Math.floor(diff/60);
      const s = diff % 60;
      timerEl.textContent = `${String(m).padStart(2,'0')} min y ${String(s).padStart(2,'0')} seg`;
    }
    tick();
    const id = setInterval(tick, 1000);

    // por si el nodo se elimina en un re-render
    const obs = new MutationObserver(() => {
      if (!document.body.contains(el)) {
        clearInterval(id);
        obs.disconnect();
      }
    });
    obs.observe(document.documentElement,{childList:true,subtree:true});
  }

  function boot(root=document){
    const el = root.querySelector('#qc-expira');
    if (el) bind(el);
  }

  document.addEventListener('DOMContentLoaded', boot);

  // re-render del drawer/cart
  new MutationObserver(ms => ms.forEach(m => m.addedNodes.forEach(n=>{
    if (n.nodeType===1) boot(n);
  }))).observe(document.documentElement,{childList:true,subtree:true});

  document.addEventListener('cart:updated', () => boot());
  document.addEventListener('drawer:open', e => boot(e.target));
})();
